import styled from "styled-components";

const Container = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;

    padding: 0.5rem;

    background: var(--card-background);
    color: var(--default-color-font);
    border-radius: 10px;

    width: 100%;

    box-shadow: rgb(0 0 0 / 15%) 0px 1px 1px, rgb(0 0 0 / 12%) 0px 1px 2px;

    transition: 200ms ease;

    ${(props) => props.color && `
        border-left: 4px solid var(--${props.color});
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    `}

    span{
        font-size: 0.9rem;
    }
    small{
        font-weight: lighter; 
        font-size: 0.8rem;
        opacity: 0.3; 
        margin: 4px 0;
    }
`;

export default Container;
